import { useMutation, useQuery, useQueryClient } from 'react-query';
import { Axios } from '@utils/api/axios-instance';
import { GET_URL, PATCH_URL } from '@utils/api/endpoints';

export type OrgPublishingPolicy = {
  organization_id: number;
  enabled: boolean;
  /** null = no restriction. */
  allowed_platforms: string[] | null;
  video_uploads_allowed: boolean;
  known_platforms: string[];
};

export type OrgPublishingPolicyPatch = {
  enabled?: boolean;
  allowed_platforms?: string[] | null;
  video_uploads_allowed?: boolean;
  include_children?: boolean;
};

const key = (orgId: number | string) => ['sysopOrgPublishing', String(orgId)];

export const useGetOrgPublishingPolicy = (orgId: number | string) =>
  useQuery<OrgPublishingPolicy>(
    key(orgId),
    async () => {
      const { data } = await Axios.get(
        GET_URL(String(orgId)).sysopOrgPublishing
      );
      return data;
    },
    { enabled: !!orgId, staleTime: 30_000, useErrorBoundary: false }
  );

export const useSetOrgPublishingPolicy = (orgId: number | string) => {
  const queryClient = useQueryClient();
  return useMutation<OrgPublishingPolicy, unknown, OrgPublishingPolicyPatch>(
    async patch => {
      const { data } = await Axios.patch(
        PATCH_URL(String(orgId)).sysopOrgPublishing,
        patch
      );
      return data;
    },
    {
      onSuccess: data => {
        queryClient.setQueryData(key(orgId), data);
      }
    }
  );
};
